<div class="ask-panel">
    <div class="ask-panel__head">
        <span class="ask-panel__icon">
            <mat-icon aria-hidden="true">{{ icon }}</mat-icon>
        </span>
        <div class="ask-panel__head-text">
            <p class="ask-panel__title">{{ title }}</p>
            <p class="ask-panel__description">{{ description }}</p>
        </div>
    </div>

    <div class="ask-panel__input-wrapper">
        <textarea class="ask-panel__input" [placeholder]="placeholder" [attr.maxlength]="maxLength"
            [disabled]="disabled" [value]="value" (input)="onInput($any($event.target).value)"
            (keydown)="onKeydown($event)"></textarea>
        <span class="ask-panel__counter">{{ value.length }} / {{ maxLength }}</span>
    </div>
    <div class="ask-panel__helper" *ngIf="helperText || selectedTemplate">
        <mat-icon aria-hidden="true">info</mat-icon>
        <span>
            <span *ngIf="helperText">{{ helperText }}</span>
            <span *ngIf="selectedTemplate" class="ask-panel__example"><strong>Example:</strong> {{ selectedTemplate.example }}</span>
        </span>
    </div>
    <!-- Conversation Thread -->
    <div #conversationThread class="conversation-thread" *ngIf="conversationHistory.length" aria-live="polite">
        <div class="thread-item" *ngFor="let msg of conversationHistory" [ngClass]="'thread-item--' + msg.role">
            <div class="thread-bubble" [ngClass]="'thread-bubble--' + msg.role">
                <span class="thread-bubble__label">{{ msg.role === 'user' ? 'You' : 'Response' }}</span>
                <span>{{ msg.text }}<ng-container *ngIf="msg.canProceed"> <a href="#" (click)="$event.preventDefault(); proceedToVisualEditor.emit()">Click here</a> to proceed with the next step.</ng-container></span>
                <div *ngIf="msg.candidateTables?.length">
                    <p>Candidate Tables:</p>
                    <ul>
                        <li *ngFor="let row of msg.candidateTables"><b>{{ row.dataset.toUpperCase() }}</b>:{{ row.description }}</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- Display the element type UI component to render based on the AI report JSON response -->
<div class="ask-panel__preview" *ngIf="selectedElementType && sqlValidation === 'PASS'">
    <div *ngIf="selectedElementType=='filter'">
        <app-inbuilt-filters-v2 [Temp]="true" [showView]="true" [elementData]="el"></app-inbuilt-filters-v2>
    </div>

    <div *ngIf="selectedElementType=='table'">
        <app-inbuilt-table-v2 [Temp]="true" [elementData]="el"></app-inbuilt-table-v2>
    </div>
    <div *ngIf="selectedElementType=='metrics'">
        <app-inbuilt-matrix [Temp]="true" [elementData]="el"></app-inbuilt-matrix>
    </div>
    <div *ngIf="selectedElementType=='drill_down_matrix'">
        <app-inbuilt-drill-down-matrix [Temp]="true" [elementData]="el"></app-inbuilt-drill-down-matrix>
    </div>
    <div *ngIf="selectedElementType=='parent_child_table'">
        <app-parent-child-table [Temp]="true" [elementData]="el"></app-parent-child-table>
    </div>
    <div *ngIf="selectedElementType=='column_chart'">
        <app-column-chart-v2 [Temp]="true" [elementData]="el"
            (headingResolved)="el.resolvedHeading = $event"></app-column-chart-v2>
    </div>
    <div *ngIf="selectedElementType=='bar_chart'">
        <app-inbuilt-bar-chart-v2 [Temp]="true" [elementData]="el"
            (headingResolved)="el.resolvedHeading = $event"></app-inbuilt-bar-chart-v2>
    </div>
    <div *ngIf="selectedElementType=='group'|| selectedElementType=='header'">

        <app-inbuilt-header-v2 [Temp]="true" [elementData]="el"
            (headingResolved)="el.resolvedHeading = $event"></app-inbuilt-header-v2>
    </div>
    <div *ngIf="selectedElementType=='card'">

        <app-inbuilt-card-v2 [Temp]="true" [elementData]="el"
            (headingResolved)="el.resolvedHeading = $event"></app-inbuilt-card-v2>
    </div>
    <div *ngIf="selectedElementType=='speedometer'">
        <app-inbuilt-speedometer-v2 [Temp]="true" [elementData]="el"></app-inbuilt-speedometer-v2>
    </div>
    <div *ngIf="selectedElementType=='stat_card'">

        <app-inbuilt-stat-card [Temp]="true" [elementData]="el"
            (headingResolved)="el.resolvedHeading = $event"></app-inbuilt-stat-card>
    </div>
    <div *ngIf="selectedElementType=='stack_chart'">

        <app-inbuilt-stack-chart [Temp]="true" [elementData]="el"
            (headingResolved)="el.resolvedHeading = $event"></app-inbuilt-stack-chart>
    </div>
    <div *ngIf="selectedElementType=='donut_chart'">
        <app-inbuilt-donut-chart [config]="{firstChange: false}" [Temp]="true" [elementData]="el"
            (headingResolved)="el.resolvedHeading = $event"></app-inbuilt-donut-chart>
    </div>
</div>
